import React, { createContext, useEffect, useReducer, useState } from 'react';
import StepWizard from 'react-step-wizard';
import AddPhotos from './AddPhotos';
import VerifyAddressHours from './VerifyAddressHours';
import Questionnaires from './Questionnaires';
import Review from './Review';
import Nav from './Nav';
import { useStore } from 'react-redux';
import { useTranslation } from 'react-i18next';
import FeedbackReducer from '../../reducers/FeedbackReducer';

import './LocationFeedback.scss';
import { isFeatureEnabled } from '../../util/features';

export const MainFeedbackContext = createContext({});

const LocationFeedback = ({ getServiceType, agent }) => {
  const [serviceType] = useState(getServiceType());
  const store = useStore();
  const address = store.getState().feedback.address;
  const locationName = store.getState().feedback.locationName;
  const dataKey = store.getState().feedback.key;
  const { t } = useTranslation();
  const tr = t('feedback', { returnObjects: true });
  const trHours = t('hours', { returnObjects: true });
  const [review, setReview] = useReducer(
    FeedbackReducer,
    store.getState().feedback
  );

  useEffect(() => {
    store.getState().agentDataMap.showNotification = false;
  });

  const getServiceTypeSelected = () => {
    return serviceType;
  };

  const isBI = () => {
    return getServiceTypeSelected() === 'business-intelligence';
  };

  const showVerifyAddressHours =
    !isBI() && isFeatureEnabled('showVerifyAddressHours');

  const steps = [
    {
      nameIndex: 0,
      show: !isBI() && isFeatureEnabled('showAddPhotos'),
      child: (
        <AddPhotos
          key="feedback-photos"
          dataKey={dataKey}
          isFeedback={true}
          isBI={isBI}
          nextStepLabel={
            showVerifyAddressHours ? undefined : trHours.buttons.next
          }
        />
      ),
    },
    {
      nameIndex: 1,
      show: showVerifyAddressHours,
      child: (
        <VerifyAddressHours
          key="feedback-hours"
          address={address}
          locationName={locationName}
        />
      ),
    },
    {
      nameIndex: 2,
      show: true,
      child: (
        <Questionnaires
          key="feedback-questions"
          getServiceType={getServiceTypeSelected}
          isBI={isBI}
        />
      ),
    },
    {
      nameIndex: 0,
      show: isBI() && isFeatureEnabled('showAddPhotos'),
      child: (
        <AddPhotos
          key="feedback-photos-bi"
          dataKey={dataKey}
          isFeedback={true}
          isBI={isBI}
        />
      ),
    },
    {
      nameIndex: 3,
      show: true,
      child: (
        <Review
          key="feedback-review"
          dataKey={dataKey}
          locationName={locationName}
          getServiceType={getServiceTypeSelected}
          isBI={isBI}
          agent={agent}
        />
      ),
    },
  ];
  const visibleSteps = steps.filter((step) => step.show);
  const stepsNames = visibleSteps.map((step) => tr.steps[step.nameIndex]);

  return (
    <MainFeedbackContext.Provider value={{ review, setReview }}>
      <div className="location-feedback">
        <StepWizard
          initialStep={1}
          isHashEnabled={true}
          nav={<Nav stepsNames={stepsNames} isBI={isBI} />}
          onStepChange={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          {visibleSteps.map((step) => step.child)}
        </StepWizard>
      </div>
    </MainFeedbackContext.Provider>
  );
};

export default LocationFeedback;
